module.exports = __webpack_public_path__ + "media/components/page-header/static/snow-badge--light-5e6e0446cae418df354e7f9368f93b13.svg";